var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEasm = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    className: "fill",
    viewBox: "0 0 18 18",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.314 14.178a7.1 7.1 0 0 1-4.844 1.918c-3.91 0-7.092-3.182-7.092-7.1A7.097 7.097 0 0 1 8.47 1.905a6.98 6.98 0 0 1 4.601 1.713L11.557 5.13a4.9 4.9 0 0 0-3.094-1.088 4.97 4.97 0 0 0-4.961 4.961c0 2.734 2.227 4.968 4.961 4.968 1.22 0 2.396-.448 3.3-1.256a.556.556 0 0 0 .044-.78.555.555 0 0 0-.779-.043 3.82 3.82 0 0 1-2.565.977 3.87 3.87 0 0 1-3.859-3.866 3.863 3.863 0 0 1 3.859-3.859c.838 0 1.632.28 2.3.78L7.89 8.798a.555.555 0 0 0 0 .78c.11.11.25.161.39.161.139 0 .279-.051.389-.162l3.285-3.285s.03-.022.037-.037l4.513-4.512a.555.555 0 0 0 0-.78.555.555 0 0 0-.78 0L13.859 2.83A8.15 8.15 0 0 0 8.47.802C3.95.802.275 4.477.275 8.997s3.675 8.202 8.195 8.202a8.2 8.2 0 0 0 5.593-2.212.555.555 0 0 0 .03-.78.555.555 0 0 0-.78-.029m2.366-8.915a1.346 1.346 0 1 0 .002 2.691 1.346 1.346 0 0 0-.002-2.691m-3.057 6.1a.935.935 0 0 1-.934-.933.935.935 0 0 1 1.867 0 .935.935 0 0 1-.933.933",
    clipRule: "evenodd"
  })));
};
export default SvgEasm;